export const CustomMasks = {
  'phone-us': '(000) 000-0000',
};
